exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .checkout-summary-cart .cart-line {\n  border-bottom: 1px solid #dddddd;\n  margin-bottom: 15px;\n}\n\n.pc .checkout-summary-cart .cart-line:first-child {\n  border-top: 1px solid #dddddd;\n}\n\n.pc .checkout-summary-cart .cart-line .header .summary-price {\n  margin-left: 7px;\n}\n\n.pc .checkout-summary-cart .cart-line .emergency-order {\n  font-family: \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-weight: normal;\n  font-size: 14px;\n}\n\n", ""]);

// exports
